<!--
Since the DivisionSwicth and the Tabs component have the same styling
and share a lot of the same beahviour, this component acts as a parent
for both
-->
<template>
  <div :class="['owc-tabs-builder', { 'owc-tabs-builder--dark': isDarkMode }]">
    <!-- Reserving the spot for the validation box given by the tabs component  -->
    <slot name="validation-box" />

    <div
      :class="{
        'owc-tabs-builder__bar-container': isFullPageTabs,
      }"
    >
      <wb-horizontal-scroll :theme="isDarkMode ? 'dark' : ''" class="wb-grid-container">
        <nav :aria-label="navigationDescription">
          <ul
            :class="[
              'owc-tabs-builder__bar',
              {
                'owc-tabs-builder__bar--with-border': !isFullPageTabs,
              },
            ]"
          >
            <!-- TODO: [try] if we use template-slot="{}" we can pass 
          the <a> direcly wich can ensure that we don't repeat
          the styles on the tabs and division switch, and also
          the <li>. But might make code more confusing/worse
        -->

            <slot name="tab-bar" />
          </ul>
        </nav>
      </wb-horizontal-scroll>
    </div>
    <slot class="owc-tabs-builder__container" name="tab-content" />
  </div>
</template>

<script lang="ts">
/**
 * `TabsBuilder` - This is a component that helps to build types of tab components, such as Tabs and Division Switcher.
 */
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { TabsBuilderComponent } from './TabsBuilder';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';

export default (ComponentInitializeDispatcher as TabsBuilderComponent).extend({
  name: 'owc-tabs-builder',
  components: {
    SlotContainer,
  },
  props: {
    isDarkMode: {
      type: Boolean,
      default: false,
    },
    navigationDescription: {
      type: String,
      default: '',
    },
    isFullPageTabs: {
      type: Boolean,
      default: true,
    },
  },
});
</script>

<style lang="scss">
.owc-tabs-builder {
  $this: &;

  display: block;

  &__container {
    @include wb-content-width;
  }
  &__bar-container {
    border-bottom: 1px solid var(--wb-grey-85);
  }
  &__bar {
    position: relative;

    display: flex;

    flex-direction: row;
    gap: var(--wb-spacing-xxs);

    &--with-border {
      border-bottom: 1px solid var(--wb-grey-85);
    }
  }
  &--dark {
    background: var(--wb-black);

    #{$this}__bar-container {
      border-bottom-color: var(--wb-grey-20);
    }
    #{$this}__bar {
      &--with-border {
        border-bottom-color: var(--wb-grey-20);
      }
    }
  }

  // Need to overwrite this class styles so that the tabs content
  // can be well aligned with the first column of the grid
  .wb-grid-container {
    margin-right: auto;
    margin-left: auto;
  }
}
</style>
